import { State } from "@/store/modules/hawkings/index";

const setShowHawkingTool = (state: State, payload: boolean) => {
    state.showHawkingTool = payload;
};

export default {
    setShowHawkingTool,
};